<template lang="">
    <div>
        <div class="app-tab-navigation">
            <div class="app-tab-navigation__breadcrumbs">
                <a class="app-tab-navigation__breadcrumb" :href="`/clients/${project.client.id}`">
                <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em" title=""><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
                {{ project.client.name }}
                </a>
                <svg class="element-icon--chevron-right element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-right"></use></svg>
                <a class="app-tab-navigation__breadcrumb" :href="`/projects/${project.id}/courses`">
                <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-breadcrumb"></use></svg>
                {{ project.name }}
                </a>
            </div>
            <h1 class="app-tab-navigation__title">Golden Source</h1>
            <ul class="app-tab-navigation__nav">
                <li>
                    <a :href="`/project-sources/${projectSource.id}/review`">Repository</a>
                </li>
                <li class="is--active">
                    <a :href="`/project-sources/${projectSource.id}/images`">Images</a>
                </li>
                <li>
                    <a :href="`/projects/${project.id}/sources/${projectSource?.id}`">Source Documents</a>
                </li>
            </ul>
        </div>
        <div class="app-project-sources-golden-source-images page-main">
            <div class="page-main__content">
                <div class="page-main__section">
                    <div class="page-main__section-header">
                        <div class="page-main__section-header-text">
                            <h2 class="page-main__section-title">Images</h2>
                            <p class="element-instructions">Review the images found during the analysis of your uploaded source documents and, If desired, add them to the project's Asset Library for potential inclusion in a course.</p>
                        </div>
                        <div v-if="projectSourceImages.length !== 0" class="page-main__buttons">
                            <AppSelect :choices="documentChoices" 
                                @update:modelValue="filterImagesByDocument"
                                placeholder="All"
                                label="Document"
                            ></AppSelect>
                            <AppSelect :choices="statusChoices" 
                                @update:modelValue="filterImagesByStatus"
                                placeholder="All"
                                label="Status"
                            ></AppSelect>
                        </div>
                    </div>
                    <AppError v-if="hasErrors"
                    v-bind="{ errors, message: errorMessage }" />

                    <div v-if="projectSourceImages.length === 0" class="element-empty-instructions">
                        <img src="/img/undraw_not-found.svg" />
                        <p>No images were found in your source document upload.</p>
                        <p>Upload source documents with images to view the images here.</p>
                    </div>

                    <div class="app-project-sources-golden-source-images__cards grid">
                        <div class="app-project-sources-golden-source-images__card col-12 col-sm-6 col-md-4 col-lg-3" v-for="image in mappedSourceImages" :key="image.id">
                            <div class="app-project-sources-golden-source-images__card-image">
                                <div class="app-project-sources-golden-source-images__card-image-header">
                                    <p v-if="image.promoted_id" class="element-badge is--success">Added to Assets</p>
                                    <div @click="viewImage(image)" class="app-project-sources-golden-source-images__card-image-zoom element-button element-button--icon">
                                        <svg class="element-icon--zoom-in element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-zoom-in"></use></svg>
                                    </div>
                                </div>
                                <img :src="'/assets/' + image.path" :alt="image.filename" />
                            </div>
                            <div class="app-project-sources-golden-source-images__card-content">
                                <h3 class="app-project-sources-golden-source-images__card-title">{{ image.filename }}</h3>
                                <p class="app-project-sources-golden-source-images__card-date">Uploaded Date: {{ localizeDate(image.created_at).format('MMM D, YYYY h:mm A') }}</p>
                                <button @click="promoteImage(image)" class="element-button--secondary element-button" :disabled="image.inProgress">
                                    <svg v-if="image.inProgress" class="element-icon--remove-circle element-icon" width="1em" height="1em"></svg>
                                    <svg v-else-if="image.promoted_id" class="element-icon--remove-circle element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-remove-circle"></use></svg>
                                    <svg v-else class="element-icon--add-circle element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-add-circle"></use></svg>
                                    {{ promoteButtonLabel(image) }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    <!-- Image Modal -->
            <div v-if="selectedImage" class="app-modal-dialog app-modal-dialog--image-zoom">
                <div class="app-modal-dialog__content" @click.stop>
                    <div class="app-modal-dialog__header">
                        <h3 class="app-modal-dialog__title">{{ selectedImage.filename }}</h3>
                        <div @click="closeModal" class="element-button element-button--icon">
                            <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
                        </div>
                    </div>
                    <div class="app-modal-dialog__body">
                        <img :src="'/assets/' + selectedImage.path" :alt="selectedImage.filename" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ProjectSourcesNavBar from './ProjectSourcesNavBar.vue';
import { localizeDate } from '../helpers/util'
import AppError from './AppError.vue';
import api from '../api/assets'
import AppSelect from './AppSelect.vue';

export default {
    name: 'ProjectSourcesImages',
    components: {
        ProjectSourcesNavBar,
        AppError,
        AppSelect
    },
    props: {
        project: {
            type: Object,
            required: true
        },
        projectSource: {
            type: Object,
            required: true
        },
        projectSourceImages: {
            type: Array,
            required: true
        },
        mediaDocuments: {
            type: [Array, Object],
            required: true
        }
    },
    data() {
        return {
            selectedImage: null,
            mappedSourceImages: [],
            documentChoices:[{id: 0, text:'All', value:'All'}],
            statusChoices: [{id:0, text:'All', value:0},{id:1, text:'Added to assets', value: 1}, {id: 2, text: 'Not Added to assets', value: 2}],
            errors: null,
            errorMessage: null,
            selectedDocument: null,
            selectedStatus: 0,
            hasErrors: false
        }
    },
    beforeMount() {
        this.mappedSourceImages = this.projectSourceImages
        this.mediaDocuments.forEach((document, index) => {
            this.documentChoices.push({id:document.id, text: document.name, value: document.id})
        })
    },
    methods:{
        localizeDate,
        promoteButtonLabel(image) {
            if (image.inProgress)
                return 'Processing...'
            else if(image.promoted_id)
                return 'Remove from Assets'
            else
                return 'Add to Assets'
        },
        async promoteImage(image) {
            try {
                image.inProgress = true
                const assetPromotion = await api.promoteSourceImage(image);

                if (assetPromotion.errors) {
                    this.hasErrors = true
                    this.errors = assetPromotion.errors || { message: 'An error occurred while promoting the image.' }
                } else {
                    this.hasErrors = false;
                    this.mappedSourceImages = this.mappedSourceImages.map(img => {
                        if (img.id === image.id)
                            return assetPromotion
                        return img;
                    });
                }
            } catch (error) {
                this.hasErrors = true
                this.errors = error.response?.data || { message: 'An error occurred while promoting the image.' }
                console.error('Error promoting image:', error)
            }
            image.inProgress = false
        },
        filterImagesByDocument(selectedDocument) {
            this.selectedDocument = selectedDocument
            this.applyFilters()
        },
        filterImagesByStatus(selectedStatus) {
            this.selectedStatus = selectedStatus
            this.applyFilters()
        },
        applyFilters() {
            let filtered = this.projectSourceImages

            if (this.selectedDocument && this.selectedDocument !== 'All') {
                filtered = filtered.filter(image => {
                    return this.selectedDocument === image.media_id
                });
            } else {
                // If 'All' is selected, show all images
                filtered = this.projectSourceImages
            }

            // Filter by status
            if (this.selectedStatus === 1) {
                filtered = filtered.filter(image => image.promoted_id)
            } else if (this.selectedStatus === 2) {
                filtered = filtered.filter(image => !image.promoted_id)
            }

            this.mappedSourceImages = filtered;
        },
        viewImage(image) {
            this.selectedImage = image
        },
        closeModal() {
            this.selectedImage = null
        }
    }
}
</script>
